import { axisClasses, barLabelClasses } from '@mui/x-charts';
import { axisColorMap, darkGray, lightGray } from '../../../theme';

export const chartStyles = () => ({
  [`.${axisClasses.root}`]: {
    [`.${axisClasses.tick}, .${axisClasses.line}`]: {
      stroke: lightGray,
      strokeWidth: 1,
    },
  },
  [`.${axisClasses.directionY}`]: {
    [`.${axisClasses.tickLabel}`]: {
      fill: axisColorMap['left'],
    },
  },
  [`.${axisClasses.directionY}.${axisClasses.right}`]: {
    [`.${axisClasses.tickLabel}`]: {
      fill: axisColorMap['right'],
    },
  },
  [`.${axisClasses.directionX}`]: {
    [`.${axisClasses.tickLabel}`]: {
      fill: darkGray,
    },
  },
  [`.${barLabelClasses.root}`]: {
    fill: 'rgb(0,0,0)',
  },
  '& .MuiBarLabel-root': {
    fontSize: '12px',
  },
});
